import React, {Fragment, useEffect} from "react";
import Dictionary from "../../../Reservation/Dictionary";
import InputErrorMessage from "../../../Reservation/InputErrorMessage";
import PersonFormFieldsForCredit from "../../PersonFormFieldsForCredit";

function PersonAddressFormForCredit(props) {

    const MARRIAGE = "MARRIAGE";
    const PROPERTY_SEPARATION_NOT_APPLICABLE = "NOT_APPLICABLE";
    const PROPERTY_SEPARATION_NO = "NO";

    let {formValidator} = props;

    let emptySpouse = {
        "pesel": "",
        "email": "",
        "phoneNumber": "",
        "location": "",
        "firstName": "",
        "lastName": "",
        "identityCardType": "ID_CARD",
        "identityCardNumber": "",
        "identityCardExpirationDate": null,
        "identityCardAuthority": "",
        "address": "",
        "postalCode": "",
        "nationality": "Polska",
        "birthDate": "",
    };

    const personChangeHandler = (event) => {
        let {name, value} = event.target;
        props.onChange({...props.person, [name]: value});
    };

    const onChange = props.onChange;

    useEffect(() => {
        if (props.person.propertySeparation) {
            if (props.person.propertySeparation === PROPERTY_SEPARATION_NO) {
                onChange({
                    ...props.person,
                    spouse: {
                        ...emptySpouse,
                        location: props.person.location,
                        address: props.person.address,
                        postalCode: props.person.postalCode
                    }
                });
            } else {
                onChange({
                    ...props.person,
                    spouse: null
                });
            }
        }
    }, [props.person.propertySeparation]);

    const maritalStatusChangeHandler = (event) => {
        let {value} = event.target;

        if (value === MARRIAGE) {
            props.onChange({
                ...props.person,
                maritalStatus: value,
                propertySeparation: PROPERTY_SEPARATION_NO
            });
        } else {
            props.onChange({
                ...props.person,
                maritalStatus: value,
                propertySeparation: PROPERTY_SEPARATION_NOT_APPLICABLE
            });
        }
    };

    const spouseChangeHandler = (spouse) => {
        props.onChange({
            ...props.person,
            spouse: {
                ...spouse,
            }
        });
    };

    let separationTypeOptions = Dictionary.createDictionaryOptionsValueAsKey(Dictionary.SEPARATION_TYPE);

    // remove last option for MARRIAGE marital status
    if (props.person.maritalStatus === MARRIAGE) {
        separationTypeOptions.splice(separationTypeOptions.length - 1, 1);
    }

    let spouseFields = null;
    if (props.person.spouse) {
        spouseFields = (
            <Fragment>
                <hr className="cr-field-full"/>
                <PersonFormFieldsForCredit
                    title="Dane małżonka"
                    person={props.person.spouse}
                    showMaritalStatus={false}
                    canRemove={false}
                    index={100}
                    onChange={spouseChangeHandler}
                    formValidator={props.formValidator}
                />
            </Fragment>
        );
    }

    return (
        <Fragment>
            <h3 className="cr-section-heading cr-field-full">Adres zamieszkania</h3>

            <div className="expert-help-field">
                <label className="expert-help-label" htmlFor="postalCode">Kod pocztowy</label>
                <input type="text"
                       id="postalCode"
                       ref={formValidator.register({required: true})}
                       name="postalCode"
                       value={props.person.postalCode}
                       onChange={personChangeHandler}/>
                <InputErrorMessage error={formValidator.errors["postalCode"]}/>
            </div>

            <div className="expert-help-field">
                <label className="expert-help-label" htmlFor="location">Miejscowość</label>
                <input type="text"
                       id="location"
                       ref={formValidator.register({required: true})}
                       name="location"
                       value={props.person.location}
                       onChange={personChangeHandler}/>
                <InputErrorMessage error={formValidator.errors["location"]}/>
            </div>

            <div className="expert-help-field cr-field-full">
                <label className="expert-help-label" htmlFor="address">Ulica, nr domu, nr lokalu, dodatkowa miejscowość</label>
                <input type="text"
                       id="address"
                       ref={formValidator.register({required: true})}
                       name="address"
                       value={props.person.address}
                       onChange={personChangeHandler}/>
                <InputErrorMessage error={formValidator.errors["address"]}/>
            </div>

            <div className="expert-help-field">
                <label className="expert-help-label" htmlFor="maritalStatus">Stan cywilny</label>
                <select id="maritalStatus"
                        ref={formValidator.register({required: true})}
                        name="maritalStatus"
                        value={props.person.maritalStatus === null ? "" : props.person.maritalStatus}
                        onChange={maritalStatusChangeHandler}>
                    <option value=""></option>
                    {Dictionary.createDictionaryOptionsValueAsKey(Dictionary.MARITAL_STATUS)}
                </select>
                <InputErrorMessage error={formValidator.errors["maritalStatus"]}/>
            </div>

            <div className="expert-help-field">
                <label className="expert-help-label" htmlFor="propertySeparation">Rozdzielność majątkowa</label>
                <select id="propertySeparation"
                        ref={formValidator.register({required: true})}
                        name="propertySeparation"
                        disabled={props.person.maritalStatus !== MARRIAGE}
                        value={props.person.propertySeparation}
                        onChange={personChangeHandler}>
                    {separationTypeOptions}
                </select>
                <InputErrorMessage error={formValidator.errors["propertySeparation"]}/>
            </div>

            {spouseFields}
        </Fragment>
    );
}

export default PersonAddressFormForCredit;
